function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import styled from "styled-components";
import { GridColumn, GridRow, H2, H3, P, Logo, Subheader, Link, ButtonPrimary, Icon } from "../";
import { withDefaultMedia } from "../MediaQueries";
const STSContainer = styled(GridColumn)`
  margin-top: 24px;
  width: 100%;
`;
const STSLogo = styled(Logo)`
  flex-shrink: 0;
  margin-right: 8px;
  width: 26px;
  height: 26px;
`;
const STSDetails = styled(GridRow)`
  margin-bottom: 14px;
  width: 100%;
`;
const VoteText = styled(P)`
  font-size: 17px;
  line-height: 22px;
  font-weight: 800;
  text-align: center;
`;
const STSButton = styled(ButtonPrimary)`
  background-color: ${props => props.theme.palette.teal.primary};
  width: 100%;
  svg {
    margin-left: 12px;
    path {
      fill: #fff;
    }
  }
  &:hover,
  &:focus {
    background-color: ${props => props.theme.palette.teal.darker};
  }
`;
export const Ticket = withDefaultMedia(({
  matches,
  show,
  preShow,
  purchased,
  stub,
  onActionClick,
  onLinkClick,
  ...props
}) => React.createElement(TicketContainer, _extends({
  stub: stub
}, props), React.createElement(Artist, {
  stub: stub,
  image: show.image
}, show.requests && !stub && React.createElement(React.Fragment, null, React.createElement(CallOut, null), React.createElement(Requests, {
  xCenter: true
}, React.createElement(STSIcon, {
  name: "SetTheSetReversed"
}), React.createElement(RequestText, null, "Accepting Song Requests"))), React.createElement(ShowDetails, {
  yEnd: true
}, React.createElement(Column, {
  xCenter: true
}, React.createElement(BoldLabel, null, show.date), React.createElement(Time, null, show.time)), React.createElement(Column, {
  xCenter: true
}, React.createElement(BoldLabel, null, "Live"), React.createElement(Time, null, show.length, " Show"))), React.createElement(Gradient, {
  stub: stub
})), React.createElement(DividerContainer, null, React.createElement(Divider, {
  variant: purchased,
  xCenter: true
}, React.createElement(Caret, {
  variant: purchased
}))), React.createElement(ArtistInfo, {
  preShow: preShow,
  stub: stub,
  xCenter: true
}, purchased && React.createElement(PurchasePill, {
  xCenter: true,
  yCenter: true
}, React.createElement(TicketIcon, {
  tertiary: true,
  name: "Ticket"
}), " You Have a Ticket"), React.createElement(ArtistName, {
  stub: stub,
  purchased: purchased
}, show.artist), React.createElement(Subheader, null, show.subtitle), !preShow && !stub && React.createElement(MoreLink, {
  onClick: onLinkClick
}, "Learn More")), matches.small && stub ? "" : React.createElement(CutLine, {
  stub: stub,
  yCenter: true
}, React.createElement(CutoutLeft, {
  stub: stub
}), React.createElement(Line, null), React.createElement(CutoutRight, {
  stub: stub
})), matches.small && stub ? "" : React.createElement(BottomContainer, {
  stub: stub,
  xCenter: true
}, purchased ? React.createElement(STSContainer, {
  xCenter: true,
  yStart: true
}, React.createElement(STSDetails, {
  xCenter: true
}, React.createElement(STSLogo, {
  name: "SetTheSetDefault"
}), React.createElement(VoteText, null, "Vote for your show\u2019s set list!")), React.createElement(STSButton, {
  onClick: onActionClick
}, "Go To Set The Set ", React.createElement(Icon, {
  tertiary: true,
  name: "Next"
}))) : React.createElement(React.Fragment, null, React.createElement(Price, {
  stub: stub
}, show.price), !stub && React.createElement(Purchase, {
  onClick: onActionClick
}, "Get Your Front Row Ticket!")))));
const PurchasePill = styled(GridRow)`
  background-color: ${props => props.theme.palette.purple.darker};
  border-radius: 24.5px;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 16px;
  margin-top: 35px;
  height: 33px;
  width: 179px;
`;
const TicketIcon = styled(Icon)`
  margin-right: 8px;
  width: 16px;
  height: 16px;
  path {
    fill: ${props => props.theme.palette.orange.primary};
  }
`;
const ShowDetails = styled(GridRow)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
`;
const CallOut = styled(GridColumn)`
  background-color: ${props => props.theme.ticket.callOut};
  border-radius: 78px;
  position: absolute;
  top: -32px;
  right: -32px;
  height: 156px;
  width: 156px;
  z-index: 2;
`;
const Requests = styled(GridColumn)`
  position: absolute;
  top: 26px;
  right: 16px;
  height: 60px;
  width: 80px;
  z-index: 3;
`;
const STSIcon = styled(Logo)`
  flex-shrink: 0;
  margin-bottom: 8px;
  height: 24px;
  width: 24px;
  path {
    fill: #fff;
  }
`;
const RequestText = styled(P)`
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  line-height: 17px;
  text-align: center;
  width: 80px;
`;
const DividerContainer = styled(GridRow)`
  background-color: #fff;
  height: 20px;
`;
const Divider = styled(GridRow)`
  background-color: ${props => props.theme.ticket.divider[props.variant ? "secondary" : "default"]};
  margin-bottom: 13px;
  height: 7px;
  width: 100%;
`;
const Caret = styled.div`
  background-color: ${props => props.theme.ticket.divider[props.variant ? "secondary" : "default"]};
  bottom: 2px;
  display: block;
  position: relative;
  transform: rotate(45deg);
  height: 18px;
  width: 18px;
`;
const CutLine = styled(GridRow)`
  background-color: #fff;
  height: ${props => props.stub ? "18px" : "16px"};
  justify-content: space-between;
  width: 100%;
`;
const CutoutLeft = styled(GridColumn)`
  background-color: ${props => props.stub ? "#FFFFFF" : props.theme.palette.black};
  border: ${props => props.stub ? `1px solid ${props.theme.palette.gray.lighter}` : "none"};
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  flex-shrink: 0;
  margin-left: -1px;
  height: ${props => props.stub ? "18px" : "16px"};
  width: ${props => props.stub ? "11px" : "9px"};
`;
const Line = styled.div`
  background-image: linear-gradient(
    to right,
    #a6aeb2 65%,
    rgba(166, 174, 178, 0) 0%
  );
  background-position: left;
  background-size: 20px 1px;
  background-repeat: repeat-x;
  margin-left: 10px;
  margin-right: 10px;
  height: 1px;
  width: 100%;
`;
const CutoutRight = styled(CutoutLeft)`
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  margin-right: -1px;
  margin-left: 0;
`;
const stubArtistStyles = `
  border-left-width: 1px;
  border-right-width: 1px;
  border-style: solid;
  margin-top: -13px;
  padding-top: 13px;
`;
const stubArtistStylesMobile = `
  border-bottom-width: 1px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;
const ArtistInfo = styled(GridColumn)`
  background-color: #fff;
  border-width: 0;
  border-color: ${props => props.theme.palette.gray.lighter};
  padding: 0 24px;
  text-align: center;
  width: 100%;
  ${props => props.stub && stubArtistStyles};
  ${Subheader} {
    line-height: 22px;
    margin-bottom: ${props => props.stub || props.preShow ? "12px" : 0};
  }
  @media only screen and ${props => props.theme.media.small} {
    ${props => props.stub && stubArtistStylesMobile}
  }
`;
const Purchase = styled(ButtonPrimary)`
  margin-top: 16px;
  width: 100%;
`;
const Price = styled(H3)`
  font-size: 25px;
  font-weight: 900;
  line-height: 29px;
  letter-spacing: 0;
  margin-top: 16px;
  text-align: center;
`;
const ArtistName = styled(H2)`
  font-size: 25px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 29px;
  margin-top: ${props => props.purchased ? 0 : "24px"};
  margin-bottom: 8px;
  @media only screen and ${props => props.theme.media.small} {
    font-size: ${props => props.stub ? "17px" : "25px"};
    line-height: ${props => props.stub ? "24px" : "29px"};
    margin-top: ${props => props.purchased ? 0 : props.stub ? "16px" : "24px"};
    margin-bottom: ${props => props.stub ? "4px" : "8px"};
  }
`;
const MoreLink = styled(Link)`
  font-size: 12px;
  height: 40px;
  justify-content: center;
  line-height: 40px;
  margin-top: 8px;
  margin-bottom: 4px;
  text-align: center;
  width: 80px;
`;
const Gradient = styled(GridRow)`
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
  bottom: 0;
  position: absolute;
  height: 138px;
  width: 100%;
  z-index: 1;
  @media only screen and ${props => props.theme.media.small} {
    height: ${props => props.stub ? "100%" : "138px"};
  }
`;
const Column = styled(GridColumn)`
  margin-bottom: 24px;
  width: 100%;
`;
const BoldLabel = styled(H2)`
  color: #fff;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0.5px;
  line-height: 32px;
  text-transform: uppercase;
`;
const Time = styled(P)`
  color: ${props => props.theme.palette.orange.primary};
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;
const Artist = styled(GridColumn)`
  background-image: url(${props => props.image});
  background-size: cover;
  background-position: center 40%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  padding-top: ${props => props.stub ? 70.4 : 84.15}%;
  position: relative;
  width: 100%;
  overflow: hidden;
  @media only screen and ${props => props.theme.media.small} {
    padding-top: ${props => props.stub ? 53.66 : 84.15}%;
  }
`;
const stubStyles = `
  border-left-width: 1px;
  border-right-width: 1px;
  border-bottom-width: 1px;
  border-style: solid;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;
const BottomContainer = styled(GridColumn)`
  background-color: #fff;
  border-width: 0;
  border-color: ${props => props.theme.palette.gray.lighter};
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding: 0 24px 24px 24px;
  text-align: center;
  width: 100%;
  overflow: hidden;
  ${props => props.stub && stubStyles};
`;
const TicketContainer = styled(GridColumn)`
  margin: 0 auto;
  overflow: hidden;
  width: 100%;
  & + & {
    margin-top: 40px;
  }
`;